import { InnerBox } from "@/components/elements/InnerBox";
import { MatchInfoItem } from "@/features/match/components/match-info/MatchInfoItem";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import {
  CollapsibleSectionHeader,
  useCollapsible,
} from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Collapse, Stack } from "@mui/material";

type TMatchCustomSystemInfoProps = {
  defaultValues: Partial<TMatchInfo>;
};

export const MatchCustomSystemInfo: FCC<TMatchCustomSystemInfoProps> = ({ defaultValues }) => {
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox showDivider={false} padding={3} borderColor={divider.high}>
      <CollapsibleSectionHeader title="システムカスタマイズ" expanded={expanded} onToggle={toggle} />

      <Collapse in={expanded}>
        <Stack mt={2} gap={1}>
          <MatchInfoItem label="求人の入力ルール" value={defaultValues?.jobInputRule} />
          <MatchInfoItem label="人材の入力ルール" value={defaultValues?.talentInputRule} />
          <MatchInfoItem label="人材の特性メモ雛形" value={defaultValues?.talentCharacteristicMemoTemplate} />
          <MatchInfoItem
            label="人材の面談評価雛形"
            value={defaultValues?.talentInterviewEvaluationTemplate}
            isShowDivider={false}
          />
        </Stack>
      </Collapse>
    </InnerBox>
  );
};
